import type { GameDefinition, GameId } from './core/types';

export type GameMetadata = Omit<GameDefinition, 'Component'>;

const entries = [
  ['wordy', 'Wordy', 'Guess the five-letter word in six valid attempts.', 45_000, 90_000],
  [
    'mini-crossword',
    'Mini Crossword',
    'Fill every open square using the Across and Down clues.',
    45_000,
    90_000,
  ],
  ['clambers', 'Clambers', 'Memorize six letters, then submit a valid anagram.', 45_000, 90_000],
  [
    'chromal',
    'Chromal',
    'Find the square with a different lightness on each level.',
    30_000,
    60_000,
  ],
  [
    'ratiole',
    'Ratiole',
    'Cut the shape so its smaller piece matches the target ratio.',
    null,
    90_000,
  ],
  ['shapeup', 'Shapeup', 'Trace the named target shape in one continuous stroke.', null, 90_000],
  ['mini-sudoku', 'Mini Sudoku', 'Complete the 6×6 grid with digits 1–6.', 45_000, 90_000],
  ['minesweeper', 'Minesweeper', 'Reveal every safe cell without opening a mine.', 45_000, 90_000],
  ['queens', 'Queens', 'Place one queen in every row, column, and region.', 45_000, 90_000],
  ['nonogram', 'Nonogram', 'Fill cells to satisfy every row and column clue.', 45_000, 90_000],
  [
    'paire',
    'Paire',
    'Complete the symbol grid using balance and pair constraints.',
    45_000,
    60_000,
  ],
] as const;

export const gameCatalog: GameMetadata[] = entries.map(
  ([id, displayName, shortRules, competitiveDelayMs, penaltyMs]) => ({
    id,
    displayName,
    shortRules,
    generatorVersion:
      id === 'shapeup' || id === 'mini-crossword' || id === 'ratiole' || id === 'nonogram'
        ? 3
        : ['clambers', 'chromal', 'minesweeper', 'mini-sudoku', 'queens', 'paire'].includes(id)
          ? 2
          : 1,
    dataVersion: id === 'wordy' || id === 'chromal' ? 2 : 1,
    skip: {
      practiceDelayMs: 0,
      competitiveDelayMs,
      penaltyMs,
    },
  }),
);

export function getGameMetadata(gameId: GameId): GameMetadata {
  const definition = gameCatalog.find((candidate) => candidate.id === gameId);
  if (!definition) throw new Error(`Unknown game: ${gameId}`);
  return definition;
}
